"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { createContext } from "react";
import { useContextStrict } from "../hooks/use-context-strict";
export const LanguageContext = createContext<unknown | null>(null);
export function useLanguageContext() {
  const context = useContextStrict(LanguageContext);
  return context;
}
export function LanguageProvider(t0) {
  const $ = _c(4);
  const {
    translations,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <LanguageTracking />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== translations) {
    t2 = <LanguageContext.Provider value={translations}>{t1}{children}</LanguageContext.Provider>;
    $[1] = children;
    $[2] = translations;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function LanguageTracking() {
  // const locale = useLocale();
  // useEffect(() => {
  //   trackingOnLanguageChange(locale);
  // }, [locale]);

  return null;
}

/**
 * Templating for translation strings
 *
 * Put variables into the translation like this `Select {label}`
 * And then template(text.my_translation, { label })
 */
export function template(text: string, variables: Record<string, string | number>) {
  let result = text;
  for (const [key, value] of Object.entries(variables)) {
    result = result.replace(`{${key}}`, String(value));
  }
  return result;
}